
import React from 'react';
import { Link } from 'react-router-dom';
import { Package, FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import AdminLayout from '@/components/layout/AdminLayout';
import axios from 'axios';

const Dashboard = () => {
  const [productCount, setProductCount] = React.useState(0);
  const [blogCount, setBlogCount] = React.useState(0);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const productsResponse = await axios.get('/api/products');
        setProductCount(productsResponse.data.length);
        const blogsResponse = await axios.get('/api/blogs');
        setBlogCount(blogsResponse.data.length);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Dashboard</h1>
        
        <div className="grid gap-6 md:grid-cols-2">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium">Products</CardTitle>
              <Package className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{productCount}</div>
              <p className="text-xs text-muted-foreground">
                Total products in the system
              </p>
              <div className="mt-4">
                <Link
                  to="/admin/products"
                  className="text-sm text-primary hover:underline"
                >
                  Manage Products
                </Link>
              </div>
            </CardContent>
          </Card>
          
          <Card>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium">Blog Posts</CardTitle>
              <FileText className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{blogCount}</div>
              <p className="text-xs text-muted-foreground">
                Total blog posts published
              </p>
              <div className="mt-4">
                <Link
                  to="/admin/blog"
                  className="text-sm text-primary hover:underline"
                >
                  Manage Blog Posts
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;
